import React, {useState, useEffect} from "react";
import { Table, Row, Col, Button, Form, Card, Collapse } from "react-bootstrap";
import AddInduction from "../AddInduction/AddInduciton";
import ProjectAPIs from "../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import ViewInduction from "./ViewInduction";
import { MdAddCircle, MdSave, MdEdit, MdCancel, MdDelete } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import DropDown from "../../../../../../DropDown/DropDown";
import LookupAPIs from "../../../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import ApiResponseHandler from "../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../../Contexts/ToastContext";

export default function ViewInductionTable({projectID}){

    const { addToast } = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [users, setUsers] = useState([]);
    const [inductionInfo, setInductionInfo] = useState([]);
    const [addInduction, setAddInduction] = useState(false);

    const [editingId, setEditingId] = useState(null);
    const [newInduction, setNewInduction] = useState({ name: "", date: "" });
    const [userID, setUserID] = useState('');
    const [date, setDate] = useState('');
    

    
    const getInductions = (projectID) => {
        ProjectAPIs.GetProjectInductionList(projectID)
        .then((inductions) => {
            setInductionInfo(inductions.data);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleAdd = () => {
        if (!userID || !date) return;
        setSending(true);

        const postJSON = {
            user_id: userID,
            date: date,
        }

        if(userID !== '' && date !== ''){
            ProjectAPIs.PostProjectInduction(projectID, postJSON)
            .then((response) => {
                if(response.status ===200){
                    handleAddNew();
                    setSending(false);
                    setUserID('');
                    setDate('');
                    addToast({ message: "Induction recorded successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                console.log(err)
                setSending(false);
                if(err.response.status === 401){
                    if(err.response.data.logout){
                        navigate('/login');
                    }
                    else{
                        window.alert(err.response.data.message)
                    }
                }
            })
        }
    };


    const getUsers = () => {
        LookupAPIs.GetUsers()
        .then((response) => {
            setUsers(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getInductions(projectID);
    }, [projectID])

    useEffect(() => {
        getUsers();
    }, []);

    const handleAddNew = () => {
        getInductions(projectID);
    }


    const ColumnHeaderData = ['Name', 'Date Completed', 'Actions'];

    const thData = () => {
        return ColumnHeaderData.map((header, index) => {
            return(
                <th key={index}>{header}</th>
            )
        })
    }


    if(loading){
        return(<div>Loading...</div>)
    }
    return(
        
        <div className="project-section">
            <div className="project-section-header">
                <h5 className="section-title">Project Induction List</h5>
                
            </div>
           
           <AddInduction projectID={projectID} handleAddNew={getInductions}/>

            {/* Desktop Table */}
            <div className="desktop-only">
                <Table striped hover responsive>
                    <thead>
                        <tr>{thData()}</tr>
                    </thead>
                    <tbody>
                        {inductionInfo.length === 0 && <tr><td colSpan={3}>No inductions</td></tr>}
                        {inductionInfo.map((item) => (
                            <ViewInduction key={item.id} induction={item} getInductionData={getInductions} desktop={true}/>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Mobile Card View */}
            <div className="moblie-only">
                {inductionInfo.map((item) => (
                    <ViewInduction key={item.id} induction={item} getInductionData={getInductions} desktop={false}/>
                   
                ))}
                </div>
        </div>



    )
            
    

}
